/**
 * Versão do sistema, exibida no rodapé.
 *
 * Linha de versão: v1.x = "Consulta Interna" (legado) → v2.0 = reescrita
 * (Spring Boot + React). Mantenha em sincronia com `package.json` e `pom.xml`
 * a cada release (`chore(release): versão X`).
 */
export const APP_VERSION = '3.5.0';
